import api from '@/api'
import { WITH_LOADING } from '@/store/action-types'
import axios from 'axios'
import { groupBy, mapValues, orderBy, reduce, values } from 'lodash'
const rootTrue = Object.freeze({ root: true })
const ALL_SYSTEM_PARAM = 'setAllSystemParam'
const ALL_PUBLIC_SYSTEM_PARAM = 'setAllPublicSystemParam'
const ALL_ADM_CODE_DETAIL = 'setAllAdmCodeDetail'
const ALL_ADDRESS = 'setAllAddress'
const ALL_COUNTRY = 'setAllCountry'
const ALL_JOBS = 'setAllJobs'
const ALL_BANKS = 'setAllBanks'
const ALL_BANKS_FC = 'setAllBanksFc'
const ALL_BRANCHS = 'setAllBranchs'
const ALL_POST_CODE = 'setAllPostCode'
const ALL_PRO_COMPANIES = 'setAllProCompanies'
const ALL_BUSINESS_CATEGORY = 'setAllBusinessCategory'
const ADM_USERS = 'setAdmUsers'
const state = function () {
  return {

    allSystemParam: [], /** 所有系統參數明細資料 */
    allAdmCodeDetail: [], /** 所有系統代碼明細資料 */
    allAddress: [],
    allCountry: [],
    allJobs: [],
    allProCompanies: [], /** 所有通路資料 */
    allBanks: [], /** 所有台幣銀行 */
    allBanksFc: [], /** 所有外幣銀行 */
    allBranchs: [], /** 所有分行 */
    allPostalCode: [], /** 所有郵局的postCode */
    allBusinessCategory: [], /** 所有的營業類別 */
    admUsers: {} /** admusers */
  }
}

const getters = {
  allProCompanies: state => {
    let result = groupBy(state.allProCompanies, 'channelCode')
    result = mapValues(result, v => groupBy(v, 'compCode'))
    return result
  },
  proCompanies: (state, getters) => payload => {
    const { channelCode = '', compCode = [] } = payload
    const all = getters.allProCompanies
    const types = all[channelCode]
    let result = []
    if (types) {
      compCode.forEach(t => {
        result = result.concat(types[t])
      })
    }
    return result
  },
  allAdmCodeDetail: state => payload => {
    let result = groupBy(state.allAdmCodeDetail, 'codeType')
    if (payload) {
      return result[payload]
    }
    return result
  },
  admCodeDetail: (state, getters) => payload => {
    const { codeType = '', codeValue, toObject = false } = payload
    let all = getters.allAdmCodeDetail()
    all = mapValues(all, v => groupBy(v, 'codeValue'))
    const types = all[codeType]
    let result = {}
    if (types) {
      if (codeValue) {
        result = reduce(
          codeValue,
          (r, v, k) => {
            if (types[v]) {
              r[v] = types[v][0]
            }
            return r
          },
          {}
        )
      } else {
        result = reduce(
          types,
          (r, v, k) => {
            r[k] = v[0]
            return r
          },
          {}
        )
      }
    }
    return toObject ? result : values(result)
  },
  allSystemParam: state => payload => {
    let result = groupBy(state.allSystemParam, 'parameterType')
    if (payload) {
      return result[payload]
    }
    return result
  },
  systemParam: (state, getters) => payload => {
    const { parameterType = '', parameterCode, toObject = false } = payload
    let all = getters.allSystemParam()
    all = mapValues(all, v => groupBy(v, 'parameterCode'))
    const types = all[parameterType]
    let result = {}
    if (types) {
      if (parameterCode) {
        result = reduce(
          parameterCode,
          (r, v, k) => {
            if (types[v]) {
              r[v] = types[v][0]
            }
            return r
          },
          {}
        )
      } else {
        result = reduce(
          types,
          (r, v, k) => {
            r[k] = v[0]
            return r
          },
          {}
        )
      }
    }
    return toObject ? result : values(result)
  },
  cityList: state => {
    let result = groupBy(state.allAddress, 'cityName')
    result = reduce(
      result,
      (r, v, k) => {
        r.push(k)
        return r
      },
      []
    )
    return result
  },
  areaMap: state => {
    let result = groupBy(state.allAddress, 'cityName')
    return result
  },
  roadMap: state => {
    let result = groupBy(state.allAddress, (item) => {
      return [item['cityName'], item['areaName']];
    })
    return result
  },
  countryList: state => {
    const afterOrder = orderBy(state.allCountry, ['showOrder'])
    return afterOrder
  },
  jobsList: state => {
    const afterOrder = orderBy(state.allJobs, ['showOrder'])
    afterOrder.forEach(e => {
      e.showName = e.careerName + ' ' + e.careerCode
    })
    return afterOrder
  },
  allPostalCode: state => state.allPostalCode,
  allBranchs: state => {
    let result = groupBy(state.allBranchs, 'bankCode')
    return result
  },
  admUserInfo: state => {
    return state.admUsers
  }
}

const mutations = {
  [ALL_PRO_COMPANIES]: (state, list) => {
    state.allProCompanies = list
  },
  [ALL_SYSTEM_PARAM]: (state, list) => {
    state.allSystemParam = list
  },
  [ALL_PUBLIC_SYSTEM_PARAM]: (state, list) => {
    state.allPublicSystemParam = list
  },
  [ALL_ADM_CODE_DETAIL]: (state, list) => {
    state.allAdmCodeDetail = list
  },
  [ALL_ADDRESS]: (state, list) => {
    state.allAddress = list
  },
  [ALL_COUNTRY]: (state, list) => {
    state.allCountry = list
  },
  [ALL_JOBS]: (state, list) => {
    state.allJobs = list
  },
  [ALL_BANKS]: (state, list) => {
    state.allBanks = list
  },
  [ALL_BANKS_FC]: (state, list) => {
    state.allBanksFc = list
  },
  [ALL_BRANCHS]: (state, list) => {
    state.allBranchs = list
  },
  [ALL_POST_CODE]: (state, list) => {
    state.allPostalCode = list
  },
  [ALL_BUSINESS_CATEGORY]: (state, list) => {
    state.allBusinessCategory = list
  },
  [ADM_USERS]: (state, admUsers) => {
    state.admUsers = admUsers
  }
}

const actions = {
  checkUiVer: ({ commit, dispatch }) => {
    const location = window.location.origin
    const baseRoute = process.env.VUE_APP_BASE_ROUTE || '/'
    const action = axios.get(location + baseRoute + 'ver.txt?t=' + new Date().getTime(), {
      headers: { 'Content-Type': 'text/plain' },
    }).then(r => {
      const localVer = require('/public/ver.txt').default.replaceAll('"', '').trim()
      // console.log('ui ver2:' + r.data + '(' + localVer + ')')
      if (r.data !== localVer && r.data.length < 20) {
        // 版號有異動
        return false
      }
      return true
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAllProCompanies: ({ commit, dispatch }) => {
    const action = api.get('/pro/proCompanyies').then(response => {
      commit(ALL_PRO_COMPANIES, response.data)
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAllAdmCodeDetail: ({ commit, dispatch }) => {
    const action = api.get('/adm/com/coded').then(response => {
      commit(ALL_ADM_CODE_DETAIL, response.data)
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAllSystemParam: ({ commit, dispatch }) => {
    const action = api.get('/adm/com/parmd').then(response => {
      commit(ALL_SYSTEM_PARAM, response.data)
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchSingleParam: ({ commit, dispatch }, payload) => {
      const params = payload
      const action = api.get('/public/adm/com/singleParmd', { params }).then(response => {
        return response
      })
      return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAddress: ({ commit, dispatch }) => {
    const action = api.get('/adm/com/zipa/city').then(response => {
      commit(ALL_ADDRESS, response.data)
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchRoadName: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/adm/com/zipa/road', { params }).then(response => {
      return response
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchCountry: ({ commit, dispatch }) => {
    const action = api.get('/adm/com/country').then(response => {
      commit(ALL_COUNTRY, response.data)
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchJobs: ({ commit, dispatch }) => {
    const action = api.get('/adm/com/career').then(response => {
      commit(ALL_JOBS, response.data)
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchPostal: ({ commit, dispatch }) => {
    const action = api.get('/adm/com/admPostalCode').then(response => {
      commit(ALL_POST_CODE, response.data)
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAdmUsers: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/adm/com/admUsers', { params }).then(r => {
      if (r.data) {
        commit(ADM_USERS, r.data)
      }
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchShareAgent: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/adm/com/shareAgent', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAppAnnexdInfoS01: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/appAnnexd/getAppAnnexdInfoS01', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  postUserAccessLog: ({ commit, dispatch }, payload) => {
    const action = api.post('/public/adm/com/userAccessLog', payload).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action, withLoading: false }, rootTrue)
  },
  fetchAdmManageDepts: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/adm/com/admManageDept', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAdmHrBranches: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/adm/com/getAdmHrBranches', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAllPublicSystemParam: ({ dispatch }, payload) => {
    const action = api.get(`/public/parmd/${payload}`).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  getGoogleSiteKey: ({ dispatch }, payload) => {
    const action = api.post('/public/adm/com/getGoogleSiteKey', payload)
    return dispatch(WITH_LOADING, { action }, { root: true })
  },
  kgibAddressCheck : ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/kgib/rest/getKgibAddress', {
      params,
      timeout: 100000 // 地址api，連server會retrey 3 次(30秒timeout)，最多90秒，這裏設100秒
    }).then(r => {
      return r
    }).catch(e => {
      return { data: {
        connectError: true
      } }
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchAllStatement: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/appAnnexd/appAnnexdInfoList', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchCellphoneSwitch: ({ commit, dispatch }, payload) => {
    const params = payload
    const action = api.get('/public/parmd/phoneSwitch', { params }).then(r => {
      return r
    })
    return dispatch(WITH_LOADING, { action }, rootTrue)
  },
  fetchSystemActiveParam: ({ commit, dispatch }, payload) => {//fix: Issue #79591，開發 停站的前台呈現與判斷
      const params = payload
      const action = api.get('/public/systemActive').then(response => {
        return response
      })
      return dispatch(WITH_LOADING, { action }, rootTrue)
  },
}
const common = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
export default common
